import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

// Components
import Header from '../header/Header'
import Main from '../main/Main'

// JS
import {
  fetchProjects,
  fetchCategories,
  setCategory,
  fetchNews,
  fetchReviews,
  fetchExhibitions
} from './actions'

// CSS
import './App.css'

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false
    }
  }

  componentDidMount() {
    this.inititalizeApp()
  }

  render() {
    const projects = this.filterProjectsToShow()

    return (
      <div className="App" onClick={this.mainAppClickHandler}>
        <Header
          currentActiveMenu={this.getCurrentMenuItem()}
          menuOpen={this.state.menuOpen}
          onToggleMenu={this.handleToggleMenu}
        />
        <Main
          projects={projects}
          categories={this.props.app.categories}
          selectedCategory={this.props.app.selectedCategory}
          onSelectCategory={this.handleSelectCategory}
          news={this.props.app.news}
          reviews={this.props.app.reviews}
          exhibitions={this.props.app.exhibitions}
        />
      </div>
    );
  }

  inititalizeApp() {
    this.loadProjects()
    this.loadNews()
    this.loadReviews()
    this.loadExhibitions()
  }

  /**
   * Load projects from the backend
   */
  loadProjects = () => {
    this.props.dispatch(fetchProjects())
    this.props.dispatch(fetchCategories())
  }

  /**
   * Load news from the backend
   */
  loadNews = () => {
    this.props.dispatch(fetchNews())
  }

  /**
   * Load reviews from the backend
   */
  loadReviews = () => {
    this.props.dispatch(fetchReviews())
  }

  /**
   * Load exhibitions from the backend
   */
  loadExhibitions = () => {
    this.props.dispatch(fetchExhibitions())
  }

  filterProjectsToShow = () => {

    if (!this.props.app.selectedCategory) {
      return this.props.app.projects
    }

    return this.props.app.projects.filter(project => project.category === this.props.app.selectedCategory)
  }

  handleSelectCategory = (category) => {
    this.props.dispatch(setCategory(category))
  }

  getCurrentMenuItem = () => {

    if (this.props.location.pathname === "/" || this.props.location.pathname.substring(0, 5) === "/work") {
      return 'Work'
    }

    if (this.props.location.pathname.substring(0, 5) === "/news") {
      return 'News'
    }

    if (this.props.location.pathname.substring(0, 12) === "/exhibitions") {
      return 'Exhibitions'
    }

    if (this.props.location.pathname.substring(0, 7) === "/review") {
      return 'Review'
    }

    if (this.props.location.pathname === "/page/about") {
      return 'About'
    }

    if (this.props.location.pathname === "/page/contact") {
      return 'Contact'
    }

    return null

  }

  /**
   * Click handler when user clicks anywhere in the app outside any buttons or other clickhandling elements
   */
  mainAppClickHandler = () => {

    if (this.state.menuOpen) {
      this.setState({ menuOpen: false })
    }

  }

  handleToggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen })
  }


}

App = withRouter(connect(function (state, ownProps) {
  return state
})(App))

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.js